module.exports = __webpack_public_path__ + "media/22.e56c93fd.mp3";